import { render, staticRenderFns } from "./file-uploadmodal.vue?vue&type=template&id=129a6386&scoped=true&"
import script from "./file-uploadmodal.vue?vue&type=script&lang=tsx&"
export * from "./file-uploadmodal.vue?vue&type=script&lang=tsx&"
import style0 from "./file-uploadmodal.vue?vue&type=style&index=0&id=129a6386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a6386",
  null
  
)

export default component.exports